import { Box, Tab, Tabs } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import AveragedCalibrationsTable from "./averaged-calibration-table";
import {
  getBaseAveragedCalibrations,
  getBrandAveragedCalibrations,
  getManufacturerAveragedCalibrations,
  getModelAveragedCalibrations,
  removeAveragedCalibrationById,
} from "../utils/NetworkHanlder";

export default function AveragedCalibrationsPage() {
  const [rowsData, setRowsData] = useState([]);
  const [clickedOption, setClickedOption] = useState(0);

  const getDataFromBackend = async () => {
    let data;
    switch (clickedOption) {
      case 0:
        data = await getBaseAveragedCalibrations();
        setRowsData(data.data);
        break;
      case 1:
        data = await getModelAveragedCalibrations();
        setRowsData(data.data);
        break;
      case 2:
        data = await getBrandAveragedCalibrations();
        setRowsData(data.data);
        break;
      case 3:
        data = await getManufacturerAveragedCalibrations();
        setRowsData(data.data);
        break;
      default:
        setRowsData([]);
    }
  };

  const handleChange = (event, newValue) => {
    setClickedOption(newValue);
  };

  const removeGroupHandler = (id) => {
    removeAveragedCalibrationById(id);
    getDataFromBackend();
  };

  useEffect(() => {
    getDataFromBackend();
  }, [clickedOption]);

  return (
    <Box>
      <Tabs
        value={clickedOption}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        aria-label="opcje uśrednionych kalibracji"
      >
        <Tab label="Bazowa" value={0} />
        <Tab label="Model" value={1} />
        <Tab label="Marka" value={2} />
        <Tab label="Producent" value={3} />
      </Tabs>

      <AveragedCalibrationsTable
        data={rowsData}
        clickedOption={clickedOption}
        removeGroupHandler={removeGroupHandler}
        updateData={getDataFromBackend}
      />
    </Box>
  );
}
